export const GroupStringConstants = {
  addUsers: 'Add Users',
  removeUsers: 'Remove Users',
  createPersona: 'Create Persona',
  updatePermissions: 'Update Permissions',
};
